<mat-toolbar class="fullscreen-toolbar" color="primary">
  <mat-toolbar-row>
    <h3>{{ 'scheduler.property.chooser.title' | translate }}</h3>

    <span class="spacer"></span>

    <a mat-icon-button matDialogClose="">
      <mat-icon>close</mat-icon>
    </a>
  </mat-toolbar-row>
</mat-toolbar>

@if (isSearchMode) {
  <mat-dialog-content>
    @if (isSearchMode) {
      <urm-property-search (propertySelected)="onPropertySelected($event)"></urm-property-search>
    }
  </mat-dialog-content>
}
@if (!isSearchMode) {
  <mat-dialog-content>
    <form #ruleForm="ngForm" (ngSubmit)="onSelectClick(ruleForm)">
      <mat-form-field>
        <label for="ruleValue">Rule Value:</label>
        <input [(ngModel)]="ruleValue" id="ruleValue" matInput name="ruleValue" required type="text">
      </mat-form-field>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button [disabled]="ruleForm && !ruleForm.valid" mat-flat-button type="submit">Add Rule</button>
    <button (click)="onCancelClick()" mat-flat-button type="button">Cancel</button>
  </mat-dialog-actions>
}